/**
 * Fleet Module Constants and Labels
 */

// Fuel Types
export const FUEL_TYPE_OPTIONS = [
  { value: "diesel", label: "Diesel" },
  { value: "essence", label: "Essence" },
  { value: "hybrid", label: "Hybride" },
  { value: "electric", label: "Électrique" },
  { value: "plugin_hybrid", label: "Hybride rechargeable" },
];

export const FUEL_TYPE_LABELS = {
  diesel: "Diesel",
  essence: "Essence",
  hybrid: "Hybride",
  electric: "Électrique",
  plugin_hybrid: "Hybride rechargeable",
};

// Vehicle Categories
export const VEHICLE_CATEGORY_OPTIONS = [
  { value: "berline", label: "Berline" },
  { value: "suv", label: "SUV" },
  { value: "break", label: "Break" },
  { value: "utilitaire", label: "Utilitaire" },
  { value: "citadine", label: "Citadine" },
  { value: "coupe", label: "Coupé" },
  { value: "cabriolet", label: "Cabriolet" },
  { value: "monospace", label: "Monospace" },
];

export const VEHICLE_CATEGORY_LABELS = {
  berline: "Berline",
  suv: "SUV",
  break: "Break",
  utilitaire: "Utilitaire",
  citadine: "Citadine",
  coupe: "Coupé",
  cabriolet: "Cabriolet",
  monospace: "Monospace",
};

// Vehicle Status
export const VEHICLE_STATUS_OPTIONS = [
  { value: "active", label: "Actif" },
  { value: "returning_soon", label: "À restituer bientôt" },
  { value: "returned", label: "Restitué" },
  { value: "sold", label: "Vendu" },
];

export const VEHICLE_STATUS_LABELS = {
  active: "Actif",
  returning_soon: "À restituer bientôt",
  returned: "Restitué",
  sold: "Vendu",
};

// Acquisition Types
export const ACQUISITION_TYPE_OPTIONS = [
  { value: "lld", label: "LLD" },
  { value: "loa", label: "LOA" },
  { value: "credit_bail", label: "Crédit-bail" },
  { value: "owned", label: "Propriété" },
];

export const ACQUISITION_TYPE_LABELS = {
  lld: "LLD",
  loa: "LOA",
  credit_bail: "Crédit-bail",
  owned: "Propriété",
};

// Contract Status
export const CONTRACT_STATUS_OPTIONS = [
  { value: "draft", label: "Brouillon" },
  { value: "active", label: "Actif" },
  { value: "terminated", label: "Résilié" },
  { value: "renewed", label: "Renouvelé" },
];

export const CONTRACT_STATUS_LABELS = {
  draft: "Brouillon",
  active: "Actif",
  terminated: "Résilié",
  renewed: "Renouvelé",
};

// Mileage Source
export const MILEAGE_SOURCE_OPTIONS = [
  { value: "declarative", label: "Déclaratif" },
  { value: "technical_control", label: "Contrôle technique" },
  { value: "maintenance", label: "Entretien" },
  { value: "other", label: "Autre" },
];

export const MILEAGE_SOURCE_LABELS = {
  declarative: "Déclaratif",
  technical_control: "Contrôle technique",
  maintenance: "Entretien",
  other: "Autre",
};

// Document Categories
export const DOCUMENT_CATEGORY_OPTIONS = [
  { value: "registration_card", label: "Carte grise" },
  { value: "insurance_card", label: "Carte verte / Attestation assurance" },
  { value: "technical_control", label: "Contrôle technique" },
  { value: "maintenance_invoice", label: "Facture entretien" },
  { value: "fuel_card", label: "Carte carburant" },
  { value: "other", label: "Autre" },
];

export const DOCUMENT_CATEGORY_LABELS = {
  registration_card: "Carte grise",
  insurance_card: "Carte verte / Attestation assurance",
  technical_control: "Contrôle technique",
  maintenance_invoice: "Facture entretien",
  fuel_card: "Carte carburant",
  other: "Autre",
};

// Alert Types
export const ALERT_TYPE_LABELS = {
  return_date: "Restitution",
  mileage_excess: "Kilométrage",
  technical_control: "Contrôle technique",
  insurance: "Assurance",
};

// Alert Priority Colors
export const ALERT_PRIORITY_COLORS = {
  critical: "bg-red-500 text-white",
  high: "bg-orange-500 text-white",
  medium: "bg-yellow-500 text-white",
  low: "bg-green-500 text-white",
};

export const ALERT_PRIORITY_BADGE_COLORS = {
  critical: "bg-red-100 text-red-800 border-red-200",
  high: "bg-orange-100 text-orange-800 border-orange-200",
  medium: "bg-yellow-100 text-yellow-800 border-yellow-200",
  low: "bg-green-100 text-green-800 border-green-200",
};

// Mileage Status Colors
export const MILEAGE_STATUS_COLORS = {
  green: "bg-green-100 text-green-800",
  orange: "bg-orange-100 text-orange-800",
  red: "bg-red-100 text-red-800",
};

export const MILEAGE_STATUS_DOT_COLORS = {
  green: "bg-green-500",
  orange: "bg-orange-500",
  red: "bg-red-500",
};

// Format helpers
export function formatMileage(km) {
  if (km === null || km === undefined) return "-";
  return `${km.toLocaleString("fr-FR")} km`;
}

export function formatCurrency(amount) {
  if (amount === null || amount === undefined) return "-";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(amount);
}

export function formatDate(dateString) {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", { timeZone: 'Europe/Paris' });
}

export function getDaysUntilLabel(days) {
  if (days === null || days === undefined) return "";
  if (days < 0) return `Dépassé de ${Math.abs(days)} j`;
  if (days === 0) return "Aujourd'hui";
  return `Dans ${days} j`;
}

export function getStatusColor(status) {
  switch (status) {
    case "active":
      return "bg-green-100 text-green-800";
    case "returning_soon":
      return "bg-orange-100 text-orange-800";
    case "returned":
      return "bg-slate-100 text-slate-800";
    case "sold":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-slate-100 text-slate-800";
  }
}
